<script lang="ts">
	//UI
	//Image
	import closeBtn from "@hitit/hub/src/assets/Icons/closeBtn.png";
	import upArrow from "@hitit/hub/src/assets/Icons/upArrow.png";
	import downArrow from "@hitit/hub/src/assets/Icons/downArrow.png";
	//Utils
	import { createEventDispatcher } from "svelte";
	import { t, store, api } from "@hitit/hub/src/stores";
	import type { PaymentTransactionData } from "@hitit/api";

	export let step: number = 1;
	export let paymentMethod = "card";
	export let loading = false;
	export let paymentTransactionDto: PaymentTransactionData | undefined;
	export let selectedPaymentMethod: string | undefined;
	export let clickType = "";

	const dispatch = createEventDispatcher();

	let successOpen = false;
	let priceCurrencyOpen = false;

	let paymentObj = {
		success: paymentTransactionDto?.success || Boolean(true),
		paymentTransactionType:
			clickType === "paymentCancel"
				? "REQUEST_REFUND"
				: paymentTransactionDto?.paymentTransactionType || "",
		createdDate: paymentTransactionDto?.createdDate || "",
		priceCurrency: paymentTransactionDto?.priceCurrency || "KRW",
		totalReceivedTax: paymentTransactionDto?.totalReceivedTax || 0,
		totalTaxablePrice: paymentTransactionDto?.totalTaxablePrice || 0,
		totalTaxFreePrice: paymentTransactionDto?.totalTaxFreePrice || 0,
		totalReceivedPrice: paymentTransactionDto?.totalReceivedPrice || 0,
		totalReceivedTip: paymentTransactionDto?.totalReceivedTip || 0,
		catResponseDTO: {
			catModel: paymentTransactionDto?.catResponseDTO?.catModel || "TS-167N",
			terminalId: paymentTransactionDto?.catResponseDTO?.terminalId || "",
			authorizationID:
				paymentTransactionDto?.catResponseDTO?.authorizationID || "",
			transactionAuthorizationTime:
				paymentTransactionDto?.catResponseDTO?.transactionAuthorizationTime ||
				"",
			cardCompany: paymentTransactionDto?.catResponseDTO?.cardCompany || "",
			storeCode: paymentTransactionDto?.catResponseDTO?.storeCode || "",
			acquirerName: paymentTransactionDto?.catResponseDTO?.acquirerName || "",
			responseMessage1:
				paymentTransactionDto?.catResponseDTO?.responseMessage1 || "",
			responseMessage2:
				paymentTransactionDto?.catResponseDTO?.responseMessage2 || "",
			processType: paymentTransactionDto?.catResponseDTO?.processType || "",
			maskedCardNumber:
				paymentTransactionDto?.catResponseDTO?.maskedCardNumber || "",
			storeID: paymentTransactionDto?.catResponseDTO?.storeID || "",
			transactionUUID:
				paymentTransactionDto?.catResponseDTO?.transactionUUID || "",
			installment: paymentTransactionDto?.catResponseDTO?.installment || "",
			totalAmount: paymentTransactionDto?.catResponseDTO?.totalAmount || "1004",
			taxedAmount: paymentTransactionDto?.catResponseDTO?.taxedAmount || "",
			taxFreeAmount: paymentTransactionDto?.catResponseDTO?.taxFreeAmount || "",
			tip: paymentTransactionDto?.catResponseDTO?.tip || "",
			tax: paymentTransactionDto?.catResponseDTO?.tax || "",
			transactionType:
				paymentTransactionDto?.catResponseDTO?.transactionType || "",
			catResponseType:
				clickType === "paymentCancel"
					? "CREDIT_REFUND"
					: paymentTransactionDto?.catResponseDTO?.catResponseType || "",
			sourceIp: paymentTransactionDto?.catResponseDTO?.sourceIp || "",
			destinationIp: paymentTransactionDto?.catResponseDTO?.destinationIp || "",
			log: paymentTransactionDto?.catResponseDTO?.log || "",
		},
		// mdeviceType: "",
		// mdeviceUUID: "",
		// mclientVersion: ""
	};

	$: console.log("!!!@?paymentTransactionDto", paymentTransactionDto);

	function successBtnHandler(value: boolean) {
		successOpen = !successOpen;
		priceCurrencyOpen = false;
		paymentObj.success = value;
	}

	function priceCurrencyBtnHandler(value: string) {
		priceCurrencyOpen = !priceCurrencyOpen;
		successOpen = false;
		paymentObj.priceCurrency = value;
	}

	function addCardPaymentHandler() {
		console.log("click!");
		dispatch("ADD_CARD_PAYMENT", {
			...paymentObj,
			clickType,
		});
	}
</script>

<div class="step-two-payment-box">
	<div class="default-info">
		<div class="row">
			<div class="item">
				<span>success</span>
				<button
					class="outer-button inputBox"
					on:click={() => successBtnHandler(paymentObj.success)}
				>
					<span class="value-text">{String(paymentObj.success)}</span>
					<img src={successOpen ? upArrow : downArrow} alt="arrow" />
				</button>
				{#if successOpen}
					<div class="button-box">
						<div class="inner-button" on:click={() => successBtnHandler(true)}>
							<span class="value-text">true</span>
						</div>
						<div class="inner-button" on:click={() => successBtnHandler(false)}>
							<span class="value-text">false</span>
						</div>
					</div>
				{/if}
			</div>
			<div class="item">
				<span>paymentTransactionType</span>
				<div class="input-wrapper inputBox">
					<input bind:value={paymentObj.paymentTransactionType} />
					<img src={closeBtn} alt="close" />
				</div>
			</div>
			<div class="item">
				<span>createdDate</span>
				<div class="input-wrapper inputBox">
					<input bind:value={paymentObj.createdDate} />
					<img src={closeBtn} alt="close" />
				</div>
			</div>
		</div>
		<div class="row">
			<div class="item">
				<span>priceCurrency</span>
				<button
					class="outer-button inputBox"
					on:click={() => priceCurrencyBtnHandler(paymentObj.priceCurrency)}
				>
					<span class="value-text">{paymentObj.priceCurrency}</span>
					<img src={priceCurrencyOpen ? upArrow : downArrow} alt="arrow" />
				</button>
				{#if priceCurrencyOpen}
					<div class="button-box">
						<div
							class="inner-button"
							on:click={() => priceCurrencyBtnHandler("KRW")}
						>
							<span class="value-text">KRW</span>
						</div>
						<div
							class="inner-button"
							on:click={() => priceCurrencyBtnHandler("USD")}
						>
							<span class="value-text">USD</span>
						</div>
					</div>
				{/if}
			</div>
			<div class="item">
				<span>totalReceivedTax</span>
				<div class="input-wrapper inputBox">
					<input type="number" bind:value={paymentObj.totalReceivedTax} />
					<img src={closeBtn} alt="close" />
				</div>
			</div>
			<div class="item">
				<span>totalTaxablePrice</span>
				<div class="input-wrapper inputBox">
					<input type="number" bind:value={paymentObj.totalTaxablePrice} />
					<img src={closeBtn} alt="close" />
				</div>
			</div>
			<div class="item">
				<span>totalTaxFreePrice</span>
				<div class="input-wrapper inputBox">
					<input type="number" bind:value={paymentObj.totalTaxFreePrice} />
					<img src={closeBtn} alt="close" />
				</div>
			</div>
		</div>
		<div class="row">
			<div class="item">
				<span>totalReceivedPrice</span>
				<div class="input-wrapper inputBox">
					<input type="number" bind:value={paymentObj.totalReceivedPrice} />
					<img src={closeBtn} alt="close" />
				</div>
			</div>
			<div class="item">
				<span>totalReceivedTip</span>
				<div class="input-wrapper inputBox">
					<input type="number" bind:value={paymentObj.totalReceivedTip} />
					<img src={closeBtn} alt="close" />
				</div>
			</div>
		</div>
	</div>
	{#if paymentMethod === "card" && (selectedPaymentMethod === undefined || selectedPaymentMethod === "INSTORE_CAT")}
		<div class="cat-response-history">
			<span>{$t("hub.order.card_terminal_approval_details")}</span>
			<div class="horizontal-var" />
		</div>
		<div class="default-info">
			<div class="row">
				<div class="item">
					<span>catModel </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.catModel} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>terminalId</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.terminalId} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>authorizationID</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.authorizationID} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>transactionAuthorizationTime</span>
					<div class="input-wrapper inputBox">
						<input
							bind:value={paymentObj.catResponseDTO
								.transactionAuthorizationTime}
						/>
						<img src={closeBtn} alt="close" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="item">
					<span><span class="mendetory">*</span>cardCompany</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.cardCompany} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>storeCode</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.storeCode} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>acquirerName</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.acquirerName} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>responseMessage1</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.responseMessage1} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="item">
					<span>responseMessage2</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.responseMessage2} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>processType</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.processType} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>maskedCardNumber</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.maskedCardNumber} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>storeID</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.storeID} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="item">
					<span>transactionUUID</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.transactionUUID} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>installment</span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.installment} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>totalAmount</span>
					<div class="input-wrapper inputBox">
						<input value="" />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>taxedAmount </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.taxedAmount} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="item">
					<span>taxFreeAmount </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.taxFreeAmount} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>tip </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.tip} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>tax </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.tax} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>transactionType </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.transactionType} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="item">
					<span>catResponseType </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.catResponseType} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>sourceIp </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.sourceIp} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>destinationIp </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.destinationIp} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
				<div class="item">
					<span>log </span>
					<div class="input-wrapper inputBox">
						<input bind:value={paymentObj.catResponseDTO.log} />
						<img src={closeBtn} alt="close" />
					</div>
				</div>
			</div>
		</div>
	{/if}
	<div class="bottom-btns">
		{#if clickType === "paymentAdd"}
			<div class="back-btn" on:click={() => (step = 1)}>
				<span>{$t("global.go_back")}</span>
			</div>
		{/if}
		<div
			class="add-payment-btn"
			class:noneBack={clickType !== "paymentAdd"}
			on:click={addCardPaymentHandler}
		>
			<span>
				{#if clickType === "paymentCancel"}
					{$t("hub.order.payment_cancel")}
				{/if}
				{#if clickType === "transactionEdit"}
					{$t("hub.order.modification_completed")}
				{/if}
				{#if clickType === "paymentTransactionAdd" && selectedPaymentMethod === "INSTORE_CASH"}
					{$t("hub.order.cash_add_payment_transaction")}
				{:else if clickType === "paymentTransactionAdd" && selectedPaymentMethod === "INSTORE_CAT"}
					{$t("hub.order.cat_add_payment_transaction")}
				{/if}
				{#if clickType === "paymentAdd" && paymentMethod === "card"}
					{$t("hub.order.add_card_payment")}
				{:else if clickType === "paymentAdd" && paymentMethod === "cash"}
					{$t("hub.order.add_cash_payment")}
				{/if}
			</span>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.step-two-payment-box {
		display: flex;
		flex-direction: column;
		padding: 20px 10px;

		.default-info {
			display: flex;
			flex-direction: column;
			gap: 20px;
		}
		.row {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 10px;
			.item {
				position: relative;
				display: flex;
				flex-direction: column;
				width: 280px;
				max-width: 280px;
				gap: 5px;

				span {
					@include appleAdjustTextForSize(16);
					color: #6d6f76;

					&.value-text {
						color: #46474b;
					}
				}
				.mendetory {
					color: red;
				}

				button {
					all: unset;
				}

				.inputBox {
					display: flex;
					justify-content: space-between;
					align-items: center;
					height: 32px;
					border-radius: 5px;
					background-color: #f0f0f4;
					padding: 0px 10px;
				}

				.outer-button {
					cursor: pointer;

					img {
						width: 15px;
						height: 7px;
					}
				}

				.button-box {
					position: absolute;
					display: flex;
					flex-direction: column;
					gap: 5px;
					top: 80px;
					width: 100%;
					max-width: 280px;
					z-index: 1;

					.inner-button {
						display: flex;
						align-items: center;
						height: 40px;
						border-radius: 5px;
						background-color: #f0f0f4;
						padding: 0px 10px;
						cursor: pointer;
					}
				}

				.input-wrapper {
					input {
						all: unset;
						@include appleAdjustTextForSize(16);
						color: #46474b;
						width: 100%;
						border-radius: 5px;
						background-color: #f0f0f4;
						padding: 0px 0px;
						padding-bottom: 3px;
					}

					img {
						width: 15px;
						height: 15px;
					}
				}
			}
		}

		.cat-response-history {
			display: flex;
			align-items: center;
			gap: 20px;
			margin: 15px 0px;
			span {
				min-width: 155px;
				@include appleAdjustTextForSize(16);
				font-weight: 550;
				color: #46474b;
			}
			.horizontal-var {
				display: none;
			}
		}

		.bottom-btns {
			display: flex;
			width: 100%;
			gap: 10px;
			margin-top: 20px;

			.back-btn {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 35%;
				height: 32px;
				background-color: #6d6f76;
				border-radius: 5px;
				cursor: pointer;
				span {
					@include appleAdjustTextForSize(16);
					font-weight: 400;
					color: white;
				}
			}

			.add-payment-btn {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 65%;
				height: 32px;
				background-color: #6591fa;
				border-radius: 5px;
				cursor: pointer;

				&.noneBack {
					width: 100%;
				}

				span {
					@include appleAdjustTextForSize(16);
					font-weight: 400;
					color: white;
				}
			}
		}
	}
	@include DesktopSize {
		.step-two-payment-box {
			padding: 30px;
			.row {
				flex-direction: row;
				.item {
					span {
						@include appleAdjustTextForSize(16, false);
					}

					.inputBox {
						height: 40px;
					}

					.outer-button {
						img {
							width: 20px;
							height: 10px;
						}
					}
					.input-wrapper {
						input {
							@include appleAdjustTextForSize(16, false);
						}
					}
				}
			}

			.cat-response-history {
				span {
					@include appleAdjustTextForSize(16, false);
				}
				.horizontal-var {
					display: block;
					width: 100%;
					height: 1px;
					background-color: #d8d9df;
				}
			}

			.bottom-btns {
				width: auto;
				gap: 20px;
				.back-btn {
					width: 25%;
					height: 40px;
					span {
						@include appleAdjustTextForSize(16, false);
					}
				}

				.add-payment-btn {
					width: 75%;
					height: 40px;

					span {
						@include appleAdjustTextForSize(16, false);
					}
				}
			}
		}
	}
</style>
